<template>
  <el-button :loading="isLoading"

   size="mini"  type="primary" @click="downloadGoods" >
   导出<span v-show="!isHideName_this">{{thisUserName}}的</span>商品  
    
   
   </el-button>
</template>

<script>
  import {
    json,
    wordData
  } from '@/common/common.js'
  import {
    ajaxPost,ajaxLogin
  } from '@/common/request.js'
  import {
    ajaxImport
  } from '@/common/request_import.js'
  import {
    utils
  } from '@/common/common.js'
  import {
    getSignStr
  } from '@/common/tool.js'
  import { saveAs } from 'file-saver'
  import moment from 'moment'

  export default {
    name: 'adminIndex',
    props: ["name","id","isHideName"],
    data() {
      return {
        importLoading:false,
        isShowUploadGroupModal:false,
        isShowAuthModal:false,
        downloadLoading:false,
        currentAuthModalObj:{},
        currentUploadModal:{},
        // fileList: [],
        // fileData:[],
        isShowAddBrandModal: false,
        currentAddModalObj: {},
        lastPage: '',
        newLinkParamObj: {},
        isShowAddOrderModal: false,
        isLoading: false,
        msg: 'Welcome to Your Vue.js App',
        formObj: {
          fuzzyQuery: '',
        },
        searchObj: {
          page: 1,
          num: 10,
        },


      }
    },
    computed: {
      isHideName_this(){
        return this.isHideName
      },
      thisUserName() {
        console.log(this.name)
        return this.name
      },
      thisUserId(){
        return this.id
      },
      adminId() {
          return utils.getAdminId()
      },
      token(){
        return utils.getToken()
      },
    },
    methods: {
      downloadGoods(){
        let _this=this
        let userName=this.thisUserName
        if(_this.isLoading){
          _this.$message({
            message: "商品正在下载中，请耐心等待", //接口返回一个页面
            type: 'warning',
            duration: 1500
          });
          return false
        }
        let tokenArg={
          token:this.token,
          adminId:this.adminId,
          userId:_this.thisUserId,
        }
        ajaxLogin('/admin/user/getTokenByAdmin', tokenArg).then(function(res) {
          console.log(res)
          if (res.errorCode == 200) {
            let userId= tokenArg.userId
            let token= res.data.token_info
            let image_type="12102"//12101为原图，12102为大图，12104为缩略图
            let item_state=""   //商品状态，0为无效（删除），1为有效（上架），2为有效但不展示（下架），留空为全量导出

            var signArg={
              user_id: userId,
              user_token: token,
              image_type:image_type,
              item_state:item_state,
            }
            var signStr=getSignStr(signArg)
            var arg = {
              user_id: userId,
              user_token: token,
              image_type:image_type,
              item_state:item_state,
              sign:signStr
            };
            var url = '/digital_warehouse_php/?s=item&op=export'
            _this.isLoading=true
            ajaxImport(url, arg).then(function(res) {
              console.log(res)
              _this.isLoading=false
              if(res.error_code=='0'){
                _this.$message({
                  message: "下载商品成功", //接口返回一个页面
                  type: 'success',
                  duration: 2000
                });
                saveAs(res.data.file, `zciiss数字云仓商品_${userName}_${moment().format("YYYY年MM月DD日HH时mm分")}`);
                // window.location.href=res.data.file
              }else{
                _this.$message({
                  message: res.error_msg||"请求报错", //接口返回一个页面
                  type: 'error',
                  duration: 1500
                });
              }
            }).catch(function(res){
              _this.isLoading=false
            })



          } else {
          }
        })
      },

    },
    created() {

    },
    mounted() {
    }
  }
</script>

<style scoped lang="scss">
  * {
    // outline: 1px solid blue;
  }



</style>



// WEBPACK FOOTER //
// src/components/downloadGoodsBtn.vue